export default {
    //意大利语
    DiagnosticReport:'Relazione diagnostica',
    troubleCode:'Codice dei guasti',
    time:'tempo',
    // 语言
    lang:{
        cn:'cinese',
        de:'Tedesco',
        en:'Inglese',
        es:'Spagnolo',
        fr:'Francese',
        it:'Italiano',
        ja:'Giapponese',
        ko:'coreano',
        pt:'portoghese'
    },
    PositioningPrompt:'Abilita la funzione di posizionamento per ottenere i prezzi locali.',
    FaultCode:'codice di errore',
    AIDiagnosis:'Diagnosi AI',
    AIWait:'Rapporto AI o in attesa di diagnosi automatica',
    FailedFaultCode:'Impossibile ottenere informazioni sul codice di guasto',
    AIError:'Analisi AI fallita',
    more:'più',
    StoredCodes:'codice di archiviazione',
    PendingCodes:'codice da elaborare',
    PermanentCodes:'codifica permanente',
    Unknown:'sconosciuto',
    ManufacturerControl:'controllo del produttore'
}